import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCreateCartIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 26,
	height: 27,
	viewBox: "0 0 26 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17.9207 3.89624H14.95V6.52084H12.3228V9.49155H14.95V12.1169H17.9207V9.49155H20.5434V6.52084H17.9207V3.89624ZM23.8332 16.4012V14.6603V11.5643H20.7516V14.6603H9.90218V6.72822C9.90218 6.36907 9.75951 6.02464 9.50556 5.77068C9.2516 5.51672 8.90716 5.37405 8.54801 5.37405H2.1665V8.46917H6.82145V16.4012C6.82145 16.7603 6.96412 17.1048 7.21808 17.3587C7.47203 17.6127 7.81647 17.7554 8.17562 17.7554H22.479C22.8382 17.7554 23.1826 17.6127 23.4365 17.3587C23.6905 17.1048 23.8332 16.7603 23.8332 16.4012ZM23.8345 21.6416C23.8428 20.3623 22.8124 19.3185 21.533 19.3102C20.2537 19.302 19.2099 20.3324 19.2016 21.6117C19.1934 22.891 20.2238 23.9348 21.5031 23.9431C22.7824 23.9513 23.8262 22.9209 23.8345 21.6416ZM9.15429 23.9436C10.4336 23.9355 11.4642 22.8919 11.4562 21.6126C11.4481 20.3333 10.4045 19.3027 9.12518 19.3107C7.84585 19.3188 6.81527 20.3624 6.82331 21.6417C6.83135 22.921 7.87496 23.9516 9.15429 23.9436Z",
		fill: "#788695"
	})
});
export default SvgCreateCartIcon;
